import React from 'react';
import { uploadIcon } from '../services/categoryService';
import '../styles/Modal.css';

interface IconUploadFieldProps {
  iconUrl: string | null;
  onIconUrlChange: (url: string | null) => void;
}

export function IconUploadField({
  iconUrl,
  onIconUrlChange,
}: IconUploadFieldProps): JSX.Element {
  const [uploading, setUploading] = React.useState(false);
  const [uploadError, setUploadError] = React.useState<string | null>(null);

  async function handleChange(
    e: React.ChangeEvent<HTMLInputElement>
  ): Promise<void> {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setUploadError(null);
    try {
      const result = await uploadIcon(file);
      onIconUrlChange(result.iconUrl);
    } catch {
      setUploadError('Icon upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className="form-field">
      <label className="form-label" htmlFor="iconFile">
        Icon (SVG or PNG)
      </label>
      <input
        id="iconFile"
        type="file"
        accept="image/svg+xml,image/png"
        className="form-input"
        onChange={handleChange}
        disabled={uploading}
      />
      {uploading && (
        <span className="icon-upload-loading">Uploading icon...</span>
      )}
      {uploadError && <span className="form-error">{uploadError}</span>}
      {iconUrl && (
        <img src={iconUrl} alt="Icon preview" className="icon-preview" />
      )}
    </div>
  );
}
